import React from "react";

import { Icon } from "@formant/ui/component/common/Icon";
import { Typography } from "@formant/ui/component/common/Typography";

import { copyToClipboard } from "../common/copyToClipboard";
import { EmptyStateContent } from "./EmptyStateContent";

export interface ILoadingProps {
    error: string;
}

export function ErrorDisplay(props: ILoadingProps) {
    const { error } = props;

    return (
        <EmptyStateContent onClick={() => copyToClipboard(error)}>
            <Icon name="error" color="var(--formant-data-red)" />
            <Typography
                type="list"
                color="var(--formant-data-red)"
                data-tooltip={error}
            >
                {error.length < 50 ? error : `${error.slice(0, 50)}...`}
            </Typography>
        </EmptyStateContent>
    );
}
